import { render, staticRenderFns } from "./index.vue?vue&type=template&id=635b4cea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=635b4cea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b4cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635b4cea')) {
      api.createRecord('635b4cea', component.options)
    } else {
      api.reload('635b4cea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=635b4cea&scoped=true", function () {
      api.rerender('635b4cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Operations/cardManage/index.vue"
export default component.exports